import React, { useCallback, useEffect, useState } from 'react'

import { ArrowUpLine, Button, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/LazyLoaded/CommunityGalleryPanel/constants'

// Floating "Go to Top" control, built on the Triangle UI <Button> and pinned next
// to the support Assistant bubble (see _go_to_top.scss for the positioning that
// keeps the two from overlapping, and for the Figma look that the secondary Button
// does not provide on its own). type="secondary" is the closest semantic (bordered,
// non-primary); _go_to_top.scss recolours it to the Figma white pill, and
// cgt-button-text-base-semibold supplies the Figma label scale (14px/20px/-0.02em).
//
// Visibility is driven by scroll position, not the "Load more" click: the button
// appears once the visitor has scrolled roughly one viewport down and hides again
// near the top, where it would be pointless. Scroll position is the more robust
// signal -- it also covers a long page-1 on mobile and never shows while the top
// is still in view -- and on this page the gallery + FAQs + CTA already make the
// page tall, so it surfaces naturally as the user scrolls.
function GoToTop() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    let frame = null
    const update = () => {
      frame = null
      setVisible(window.scrollY > window.innerHeight)
    }
    // Coalesce scroll/resize bursts into one rAF-throttled read to keep the
    // handler off the main scroll path.
    const handleScroll = () => {
      if (frame) return
      frame = window.requestAnimationFrame(update)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    window.addEventListener('resize', handleScroll, { passive: true })
    update()
    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
      if (frame) window.cancelAnimationFrame(frame)
    }
  }, [])

  const handleClick = useCallback(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' })
  }, [])

  const customClass = `ai-sub-landing__go-to-top cgt-button-text-base-semibold${
    visible ? ' ai-sub-landing__go-to-top--visible' : ''
  }`

  return (
    <Button
      type="secondary"
      actionType="button"
      customClass={customClass}
      icon={<Icon svgComponent={ArrowUpLine} size={iconSize} color="darker" />}
      aria-label="Go to top"
      onClick={handleClick}
    >
      Go to Top
    </Button>
  )
}

export default GoToTop
